import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.browser.window
import theme.BankoTheme

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    KoinInitializer().init()

    try {
        // The web app's own Firebase config (Project settings → Web app). GitLive maps these onto
        // the JS SDK's options: applicationId→appId, gcmSenderId→messagingSenderId. Analytics is
        // handled separately by gtag.js in index.html, so measurementId is intentionally omitted.
        Firebase.initialize(
            Unit,
            FirebaseOptions(
                applicationId = "1:446292912165:web:66ac60a4f4a3e6eb6577cc",
                apiKey = "AIzaSyA0SBGsISo09MtR1R9hN9iRWEINfs_RU4w",
                projectId = "bankothegame",
                gcmSenderId = "446292912165",
                storageBucket = "bankothegame.firebasestorage.app",
                authDomain = "bankothegame.firebaseapp.com",
            ),
        )
    } catch (e: Throwable) {
        // Don't let a web Firebase-config issue blank the whole app; local play still works.
        println("Firebase init failed on web: ${e.message}")
    }

    // Handle invite deep links on web: bankothegame.com/join?code=ABCDE pre-fills (and auto-joins
    // when a name is saved), mirroring the Android intent path. On mobile with the app installed,
    // verified App Links open the native app instead and the browser never loads this.
    if (InviteLinks.extractCode(window.location.href) != null) {
        try {
            val suggestedName = window.sessionStorage.getItem("banko_invite_name")
            window.sessionStorage.removeItem("banko_invite_name")
            InviteLinks.setSuggestedPlayerName(suggestedName)
        } catch (_: Throwable) {
            // Storage can be unavailable in strict/private browser modes; the regular name field remains.
        }
    }
    InviteLinks.onDeepLink(window.location.href)

    ComposeViewport(viewportContainerId = "webApp") {
        BankoTheme {
            App()
        }
    }
}
